
















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { TempUsersSearchDTO, userService } from "@/services/user";
import { User } from "@/swagger/models";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "UserSelector",
})
export default class UserSelector extends Vue {
    @Prop({ required: true })
    customerId: number;

    @Prop()
    filteredUsers: User[];

    @Prop({ default: "Select user" })
    label: string;

    users: User[] = [];
    loading: boolean = false;

    @Prop()
    searchParams: TempUsersSearchDTO;

    @Prop({ default: false })
    returnObject: boolean;

    @Prop({})
    filter: (user: User) => boolean;

    @Watch("customerId", { immediate: true })
    async refreshUsers() {
        try {
            this.loading = true;
            this.users = await userService.search({
                customer: this.customerId,
                ...this.searchParams,
            });
        } catch (e) {
            console.warn(e);
        } finally {
            this.loading = false;
        }
    }
}
